import { render, staticRenderFns } from "./button-blue.vue?vue&type=template&id=4d276288&scoped=true&"
import script from "./button-blue.vue?vue&type=script&lang=js&"
export * from "./button-blue.vue?vue&type=script&lang=js&"
import style0 from "./button-blue.vue?vue&type=style&index=0&id=4d276288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d276288",
  null
  
)

export default component.exports